import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MemberNoteService } from 'src/app/project-display/data-access/member-note.service';
import { IProjectNote } from 'src/app/project-display/interfaces/IProjectNote';

interface CreateMemberNoteDialogData {
  projectID: number;
}

@Component({
  selector: 'eic-create-member-note-dialog',
  templateUrl: './create-member-note-dialog.component.html',
  styleUrl: './create-member-note-dialog.component.scss'
})
export class CreateMemberNoteDialogComponent {
  readonly maxNoteLength = 999;
  memberNoteText = '';
  isSaving = false;

  constructor(
    private dialogRef: MatDialogRef<CreateMemberNoteDialogComponent>,
    private memberNoteService: MemberNoteService,
    @Inject(MAT_DIALOG_DATA) public data: CreateMemberNoteDialogData
  ) {
  }

  get charsLeft(): number {
    return this.maxNoteLength - (this.memberNoteText?.length ?? 0);
  }

  get canSave(): boolean {
    return !!(this.memberNoteText || '').trim().length && !this.isSaving;
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    if (!this.canSave) return;

    this.isSaving = true;
    this.memberNoteService
      .create(this.data.projectID, this.memberNoteText)
      .subscribe({
        next: (newNote: IProjectNote) => this.dialogRef.close(newNote),
        error: () => {
          this.isSaving = false;
        }
      });
  }
}
